import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { interval, Subscription, Observable } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { PurchasingService } from '../../services/purchasing.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { Location } from '@angular/common'

@Component({
	selector: 'app-vendor-invoice',
	templateUrl: './vendor-invoice.component.html',
	styleUrls: ['./vendor-invoice.component.scss']
})
export class VendorInvoiceComponent implements OnInit {

	invoiceForm: FormGroup;
	separatorKeysCodes: number[] = [ENTER, COMMA];
	vendor_data: any = [];
	open_grns: any = [];
	all_open_grns: any = [];
	selected_grns: any = [];
	selected_grnbatches: any = [];
	invoice_grns: any = [];
	invoiceTotal = 0.00;
	taxTotal = 0.00;
	totalTotal = 0.00;
	glcharges: any = [];
	glaccounts: any = [];
	taxes: any = [];
	today = new Date();
	overide_tax = false;
	grn_batches: any = [];
	all_grn_batches: any = [];
	discount: any = 0.00;
	user: any = [];
	errors: any = [];
	color: any = '';
	sending = false;
	allglaccounts: any = [];
	@ViewChild('grnInput') grnInput: ElementRef < HTMLInputElement > ;
	//@ViewChild('glcharge') glcharge: ElementRef < HTMLInputElement > ;

	@Output() newvendortrans = new EventEmitter<boolean>();

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private vendorService: VendorService, public router: Router, private location: Location, private globalsService: GlobalsService, public purchasingService: PurchasingService, private globalSearchService: GlobalSearchService) {
		this.color = this.globalSearchService.getColor()
		this.globalSearchService.user.subscribe((user: any) => {
			this.user = user
		});

	}

	ngOnInit(): void {

		this.route.params.subscribe(params => {
			const supplierid = params['id'];

			this.vendorService.getVendor(supplierid).subscribe((results: any) => {
				this.vendor_data = results;

				this.purchasingService.getGrnDetails(this.vendor_data.supplierid).subscribe((r: any) => {
					this.open_grns = r;
					this.all_open_grns = r;
				})

				this.purchasingService.getOpenGrnBatches(this.vendor_data.supplierid).subscribe((r: any) => {
					this.grn_batches = r;
					this.all_grn_batches = r;
				})
				const due = new Date(this.vendor_data.duedate)

				this.invoiceForm = this.fb.group({
					reference: ['', [Validators.required]],
					invoiceDate: [this.today, [Validators.required]],
					discountAmount: [0.00, [Validators.pattern('[0-9.]*')]],
					discountDate: [due, [Validators.required]],
					dueDate: [due, [Validators.required]],
					rate: [this.vendor_data.exrate, [Validators.pattern('[0-9.]*')]],
					grns: [''],
					glsearch: ['']
				});



				this.invoiceForm.get('grns').valueChanges.subscribe(newValue => {

					if (newValue != '') {
						this.grn_batches = this.globalSearchService.filterItem(this.all_grn_batches, newValue, 'grnbatch,grnno,orderno,itemcode')
					} else {
						this.grn_batches = this.all_grn_batches
					}

				});

				this.invoiceForm.markAllAsTouched();
			});
		});
	}

	back(): void {
		this.location.back()
	}

	add(event: MatChipInputEvent): void {
		const value = (event.value || '').trim();

		// Add our fruit
		if (value) {
			this.selected_grns.push(value);
		}

		// Clear the input value
		//event.chipInput!.clear();
		this.grnInput.nativeElement.value = '';
		this.invoiceForm.controls['grns'].setValue(null);
		this.getTotal();
	}

	removeLine(grn: any): void {
		const index = this.selected_grns.indexOf(grn);

		if (index >= 0) {
			this.selected_grns.splice(index, 1);
		}
		this.getTotal();
	}

	remove(grn: any): void {
		let index = this.selected_grns.indexOf(grn);

		if (index >= 0) {
			this.selected_grns.splice(index, 1);
		}

		index = this.selected_grnbatches.indexOf(grn);
		//add back to the list
		this.grn_batches.push(this.selected_grnbatches[index]);

		if (index >= 0) {
			this.selected_grnbatches.splice(index, 1);
		}

		//remove items too?
		const selected = this.selected_grns.filter((line: any) => {
			return parseFloat(line.orderno) != parseFloat(grn.orderno);
		});

		this.selected_grns = selected;

		this.getTotal();
	}


	selected(event: MatAutocompleteSelectedEvent): void {

		const index = this.grn_batches.indexOf(event.option.value);
		//add to chip list
		this.selected_grnbatches.push(event.option.value)

		const moving_grn = event.option.value.orderno

		this.grn_batches.splice(index, 1);

		//map returns just the array value. filter will be list of all
		this.open_grns.filter((grn: any) => {
			if (grn.orderno == moving_grn) {
				this.selected_grns.push(grn);
			}
			return grn.orderno == moving_grn;
		})

		this.grnInput.nativeElement.value = '';
		this.invoiceForm.controls['grns'].setValue(null);
		this.getTotal();
	}

	removeGl(gl: string): void {
		const index = this.glcharges.indexOf(gl);

		if (index >= 0) {
			this.glcharges.splice(index, 1);
		}
		this.getTotal();
	}

	setTaxValue(event: any, tax: any) {
		this.overide_tax = true;
		const index = this.vendor_data.taxes.indexOf(tax);
		this.vendor_data.taxes[index].taxamount = event.target.value;
		this.getTotal();
	}

	setQty(event: any, grn: any) {
		const index = this.selected_grns.indexOf(grn);
		if (parseFloat(event.target.value) > parseFloat(this.selected_grns[index].qtyrecd)) {
			event.target.value = parseFloat(this.selected_grns[index].qtyrecd);
		}

		this.selected_grns[index].toinvoice = event.target.value;
		this.getTotal();
	}

	setDiscount(event: any) {
		this.discount = parseFloat(event.target.value);
		this.getTotal();
	}

	setPrice(event: any, grn: any) {
		const index = this.selected_grns.indexOf(grn);
		this.selected_grns[index].unitprice = event.target.value;
		this.getTotal();
	}

	setGlPrice(event: any, gl: any) {
		const index = this.glcharges.indexOf(gl);
		this.glcharges[index].value = event.target.value;
		this.getTotal();
	}

	getSubTotal() {
		let itemtotal = 0
		itemtotal = this.selected_grns.reduce(function(accumulator, items) {
			return parseFloat(accumulator) + parseFloat(items.unitprice) * parseFloat(items.toinvoice);
		}, 0);

		let gltotal = 0
		gltotal = this.glcharges.reduce(function(accumulator, items) {
			return parseFloat(accumulator) + parseFloat(items.value);
		}, 0);
		const total = gltotal + itemtotal;
		this.invoiceTotal = total
		return total;

	}

	getTaxTotal(subtotal: any) {

		if (!this.overide_tax) {
			this.vendor_data.taxes.forEach((tax, index) => {
				const value = parseFloat(tax.taxrate) * parseFloat(subtotal)
				this.vendor_data.taxes[index].taxamount = value;
			});
		}

		let taxtotal = 0
		taxtotal = this.vendor_data.taxes.reduce(function(accumulator, tax) {
			return (parseFloat(accumulator) + parseFloat(tax.taxamount));
		}, 0);

		this.taxTotal = taxtotal
		return taxtotal;
	}

	get rateDisplay(): string {
		// Display the rate as a percentage (e.g., 1 -> "100")
		return (this.invoiceForm.get('rate')?.value * 100).toFixed(4);
	}

	onRateInput(event: Event): void {
		const input = (event.target as HTMLInputElement).value;
		const numericValue = parseFloat(input) / 100; // Convert "100" back to "1"
		this.invoiceForm.get('rate')?.setValue(numericValue);
	}

	getTotal() {

		const subtotal = this.getSubTotal();
		const taxtotal = this.getTaxTotal(subtotal);
		this.totalTotal = subtotal + taxtotal - this.discount;
	}

	filteredGrnBatches(): any[] {
	  if (!this.selected_grnbatches || this.selected_grnbatches.length === 0) {
			return this.grn_batches; // Return all if nothing is selected
	  }

	  const selectedBatchIds = new Set(this.selected_grnbatches.map(batch => batch.grnbatch));

	  return this.grn_batches.filter(grn => !selectedBatchIds.has(grn.grnbatch));
	}


	addGl(event: any) {
		const selection = event.option.value
		//{accountcode: "1", accountname: "Default Account", group: "Sales"}
		const newGlCharge = {
			account: selection.accountcode,
			name: selection.accountname,
			value: 0.00,
			quantity: 1,
			group: selection.group,
			description: '',
		};

		this.glcharges.push(newGlCharge);
		//this.glcharge.nativeElement.value = '';

	}

	onSubmit() {
		this.getTotal();
		this.errors = false;
		for (const el in this.invoiceForm.controls) {
			if (this.invoiceForm.controls[el].errors) {
				this.errors = true;
			}
		}

		if (this.invoiceForm.valid) {
			this.sending = true;
			const data = {
				vendor: this.vendor_data,
				header: this.invoiceForm.value,
				grns: this.selected_grns,
				glcharges: this.glcharges,
				subtotal: this.invoiceTotal,
				taxes: this.taxTotal,
				total: this.totalTotal,
				user: this.user,
			}

			this.vendorService.createInvoice(data).subscribe((result: any) => {
				this.sending = false;
				if (result.success) {
					this.globalSearchService.showNotification('#' + result.transno + ' Created', 'success', 'bottom', 'right');

					const due = new Date(this.vendor_data.duedate)
					this.invoiceForm.reset();

					this.invoiceForm = this.fb.group({
						reference: ['', [Validators.required]],
						invoiceDate: [this.today, [Validators.required]],
						discountAmount: [0.00, [Validators.pattern('[0-9.]*')]],
						discountDate: [due, [Validators.required]],
						dueDate: [due, [Validators.required]],
						rate: [this.vendor_data.exrate, [Validators.pattern('[0-9.]*')]],
						grns: ['']
					});

					this.glcharges = [];
					this.selected_grns = [];
					this.selected_grnbatches = [];

					this.totalTotal = 0;
					this.taxTotal = 0;
					this.discount = 0;

					this.invoiceForm.get('grns').valueChanges.subscribe(newValue => {
						if (newValue != '') {
							this.open_grns = this.globalSearchService.filterItem(this.all_open_grns, newValue, 'grnbatch,grnno,orderno,itemcode')
						} else {
							this.open_grns = this.all_open_grns
						}
					});

					this.newvendortrans.emit(this.vendor_data.supplierid);

					this.invoiceForm.markAllAsTouched();

				} else {

				}
				//this.router.navigate(['/vendors/invoice/complete/'+result.transno]);
			});
		} else {
			this.globalSearchService.getFormValidationErrors(this.invoiceForm);
		}
	}

	ngAfterViewInit() {
		this.globalsService.getGLAccounts().subscribe((result: any) => {
			this.glaccounts = result;
			this.allglaccounts = result;
		});

		this.globalsService.getTaxes().subscribe((result: any) => {
			this.taxes = result;
		});

	}
}